import { ref } from 'vue';
import { updateApplicationMemo } from '../api/updateApplicationMemo';
import { handleUpdateApplicationError } from '../lib/handleUpdateApplicationError';

/**
 * 管理メモ更新カスタムフック
 *
 * 申込情報の一括更新とは独立しており、ロール・配送ステータスによる制限はない。
 */
export const useUpdateApplicationMemo = () => {
    const isLoading = ref(false);
    const error = ref<string | null>(null);

    /**
     * 管理メモを更新する
     *
     * @param applicationId 申込ID
     * @param memo 管理メモ（空の場合はnullで消去）
     * @returns 成功時はtrue、失敗時はfalse
     */
    const update = async (applicationId: string, memo: string | null): Promise<boolean> => {
        isLoading.value = true;
        error.value = null;

        try {
            await updateApplicationMemo(applicationId, { memo });
            return true;
        } catch (caughtError: unknown) {
            error.value = handleUpdateApplicationError(caughtError);
            return false;
        } finally {
            isLoading.value = false;
        }
    };

    /**
     * エラーをクリアする
     */
    const clearError = () => {
        error.value = null;
    };

    return {
        isLoading,
        error,
        update,
        clearError,
    };
};
